import { addDays as r } from "./addDays.js";
function o(a, d, e) {
  return r(a, d * 7, e);
}
export {
  o as addWeeks,
  o as default
};
